import React from 'react'

import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new"
import {EntityType} from "../../../../../gd/const/item"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import FormError from "../../../../../gd-form/common/form-error/form-error"
import ProjectSession from "../../../../../model2/project/project-session"
import FormManager from "../../../../../gd-form/common/form-manager"

type Props = {
    project             : ProjectSession
    form                : FormManager

    onParentSelected    : {(projectId: ID): void}
}

export default function ProjectForm_NewLocation(props: Props) {
    return (
        <div className="row">
            <div className="label">New location</div>
            <div className="element">
                <SelectParentNew projectId              = {props.project.parentId}
                                 parentsFor             = {EntityType.PROJECT}
                                 renderType             = {SelectParent_RenderType.FORM}
                                 canBeNull              = {gd.spaces.projects.enabled}
                                 displayWorkspaceRoot   = {true}
                                 onChange               = {props.onParentSelected}/>

                <FormError form={props.form} name="company" />
                <FormError form={props.form} name="parentProject" />
            </div>
        </div>
    )
}
